import React from "react";
import { Row, Col } from "reactstrap";
import "./checkoutResponse.css";

const StripeSubscriptionCheckoutFailure = () => {
  return (
    <div className="bl-back-image">
      <Row>
        <Col xl="12" lg="12" md="12" sm="12" xm="12" style={{ marginTop: "10%" }}>
          <div>
            <h1 className="text-center text-danger text-congrats">
              Subscription Not Completed :(
            </h1>

            <div className="text-center pl-2 pr-2" style={{ fontSize: "20px", marginTop: "40px" }}>
              <p>
                Your subscription checkout was cancelled or could not be completed. No charges were made.
              </p>
            </div>

            <div className="text-center mt-5">
              <a href="/subscription" className="btn btn-primary btn-lg mr-3">
                <span className="fas fa-redo pr-2"></span>
                Try Again
              </a>
              <a href="/dashboard" className="btn btn-outline-primary btn-lg">
                <span className="fas fa-home pr-2"></span>
                Return to Dashboard
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StripeSubscriptionCheckoutFailure;
